var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeAccountCtaLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 29,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#908F96",
    d: "M19.5 9.667h-1.333V7A6.67 6.67 0 0 0 11.5.333 6.67 6.67 0 0 0 4.833 7v2.667H3.5a2.675 2.675 0 0 0-2.667 2.666v13.334c0 1.466 1.2 2.666 2.667 2.666h16c1.467 0 2.667-1.2 2.667-2.666V12.333c0-1.466-1.2-2.666-2.667-2.666ZM7.5 7c0-2.213 1.787-4 4-4s4 1.787 4 4v2.667h-8V7Zm12 18.667h-16V12.333h16v13.334Zm-8-4c1.467 0 2.667-1.2 2.667-2.667 0-1.467-1.2-2.667-2.667-2.667A2.674 2.674 0 0 0 8.833 19c0 1.467 1.2 2.667 2.667 2.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeAccountCtaLock);
export default __webpack_public_path__ + "static/media/free-account-cta-lock.6ea5da401c8153c47a30cf09561af406.svg";
export { ForwardRef as ReactComponent };